/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateTodo = /* GraphQL */ `
  subscription OnCreateTodo($filter: ModelSubscriptionTodoFilterInput) {
    onCreateTodo(filter: $filter) {
      id
      authorID
      author {
        id
        first
        last
        email
        phone
        birthday
        department
        director
        joinDate
        unitPrice
        enabled
        role
        corporateIDs
        remarks
        widgets {
          name
          enabled
          __typename
        }
        employmentType
        paidRemain
        paidHoursUsed
        dailyWorktime
        createdAt
        updatedAt
        __typename
      }
      title
      description
      start
      end
      fillColor
      textColor
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateTodo = /* GraphQL */ `
  subscription OnUpdateTodo($filter: ModelSubscriptionTodoFilterInput) {
    onUpdateTodo(filter: $filter) {
      id
      authorID
      author {
        id
        first
        last
        email
        phone
        birthday
        department
        director
        joinDate
        unitPrice
        enabled
        role
        corporateIDs
        remarks
        widgets {
          name
          enabled
          __typename
        }
        employmentType
        paidRemain
        paidHoursUsed
        dailyWorktime
        createdAt
        updatedAt
        __typename
      }
      title
      description
      start
      end
      fillColor
      textColor
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteTodo = /* GraphQL */ `
  subscription OnDeleteTodo($filter: ModelSubscriptionTodoFilterInput) {
    onDeleteTodo(filter: $filter) {
      id
      authorID
      author {
        id
        first
        last
        email
        phone
        birthday
        department
        director
        joinDate
        unitPrice
        enabled
        role
        corporateIDs
        remarks
        widgets {
          name
          enabled
          __typename
        }
        employmentType
        paidRemain
        paidHoursUsed
        dailyWorktime
        createdAt
        updatedAt
        __typename
      }
      title
      description
      start
      end
      fillColor
      textColor
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateAppOption = /* GraphQL */ `
  subscription OnCreateAppOption(
    $filter: ModelSubscriptionAppOptionFilterInput
  ) {
    onCreateAppOption(filter: $filter) {
      name
      tag
      value
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateAppOption = /* GraphQL */ `
  subscription OnUpdateAppOption(
    $filter: ModelSubscriptionAppOptionFilterInput
  ) {
    onUpdateAppOption(filter: $filter) {
      name
      tag
      value
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteAppOption = /* GraphQL */ `
  subscription OnDeleteAppOption(
    $filter: ModelSubscriptionAppOptionFilterInput
  ) {
    onDeleteAppOption(filter: $filter) {
      name
      tag
      value
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateSequence = /* GraphQL */ `
  subscription OnCreateSequence($filter: ModelSubscriptionSequenceFilterInput) {
    onCreateSequence(filter: $filter) {
      name
      tag
      count
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateSequence = /* GraphQL */ `
  subscription OnUpdateSequence($filter: ModelSubscriptionSequenceFilterInput) {
    onUpdateSequence(filter: $filter) {
      name
      tag
      count
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteSequence = /* GraphQL */ `
  subscription OnDeleteSequence($filter: ModelSubscriptionSequenceFilterInput) {
    onDeleteSequence(filter: $filter) {
      name
      tag
      count
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateUser = /* GraphQL */ `
  subscription OnCreateUser($filter: ModelSubscriptionUserFilterInput) {
    onCreateUser(filter: $filter) {
      id
      first
      last
      email
      phone
      birthday
      department
      director
      joinDate
      unitPrice
      enabled
      role
      corporateIDs
      remarks
      widgets {
        name
        enabled
        __typename
      }
      employmentType
      paidRemain
      paidHoursUsed
      dailyWorktime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateUser = /* GraphQL */ `
  subscription OnUpdateUser($filter: ModelSubscriptionUserFilterInput) {
    onUpdateUser(filter: $filter) {
      id
      first
      last
      email
      phone
      birthday
      department
      director
      joinDate
      unitPrice
      enabled
      role
      corporateIDs
      remarks
      widgets {
        name
        enabled
        __typename
      }
      employmentType
      paidRemain
      paidHoursUsed
      dailyWorktime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteUser = /* GraphQL */ `
  subscription OnDeleteUser($filter: ModelSubscriptionUserFilterInput) {
    onDeleteUser(filter: $filter) {
      id
      first
      last
      email
      phone
      birthday
      department
      director
      joinDate
      unitPrice
      enabled
      role
      corporateIDs
      remarks
      widgets {
        name
        enabled
        __typename
      }
      employmentType
      paidRemain
      paidHoursUsed
      dailyWorktime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateRole = /* GraphQL */ `
  subscription OnCreateRole($filter: ModelSubscriptionRoleFilterInput) {
    onCreateRole(filter: $filter) {
      id
      name
      functions {
        name
        enabled
        permission
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateRole = /* GraphQL */ `
  subscription OnUpdateRole($filter: ModelSubscriptionRoleFilterInput) {
    onUpdateRole(filter: $filter) {
      id
      name
      functions {
        name
        enabled
        permission
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteRole = /* GraphQL */ `
  subscription OnDeleteRole($filter: ModelSubscriptionRoleFilterInput) {
    onDeleteRole(filter: $filter) {
      id
      name
      functions {
        name
        enabled
        permission
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateCustomer = /* GraphQL */ `
  subscription OnCreateCustomer($filter: ModelSubscriptionCustomerFilterInput) {
    onCreateCustomer(filter: $filter) {
      id
      email
      passwd
      serial
      name
      office
      post
      pref
      address
      build
      tel
      fax
      url
      agencyID
      closing
      payment
      rate
      charge
      salesID
      color
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateCustomer = /* GraphQL */ `
  subscription OnUpdateCustomer($filter: ModelSubscriptionCustomerFilterInput) {
    onUpdateCustomer(filter: $filter) {
      id
      email
      passwd
      serial
      name
      office
      post
      pref
      address
      build
      tel
      fax
      url
      agencyID
      closing
      payment
      rate
      charge
      salesID
      color
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteCustomer = /* GraphQL */ `
  subscription OnDeleteCustomer($filter: ModelSubscriptionCustomerFilterInput) {
    onDeleteCustomer(filter: $filter) {
      id
      email
      passwd
      serial
      name
      office
      post
      pref
      address
      build
      tel
      fax
      url
      agencyID
      closing
      payment
      rate
      charge
      salesID
      color
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateCorporate = /* GraphQL */ `
  subscription OnCreateCorporate(
    $filter: ModelSubscriptionCorporateFilterInput
  ) {
    onCreateCorporate(filter: $filter) {
      id
      name
      furigana
      post
      pref
      address
      build
      tel
      fax
      logo
      sign
      bank {
        items {
          id
          corporateID
          corporate {
            id
            name
            furigana
            post
            pref
            address
            build
            tel
            fax
            logo
            sign
            slipFormat
            startMonth
            invoice
            createdAt
            updatedAt
            __typename
          }
          name
          store
          type
          no
          owner
          sort
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      office {
        items {
          id
          corporateID
          corporate {
            id
            name
            furigana
            post
            pref
            address
            build
            tel
            fax
            logo
            sign
            slipFormat
            startMonth
            invoice
            createdAt
            updatedAt
            __typename
          }
          name
          post
          pref
          address
          build
          tel
          fax
          sort
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      slipFormat
      startMonth
      invoice
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateCorporate = /* GraphQL */ `
  subscription OnUpdateCorporate(
    $filter: ModelSubscriptionCorporateFilterInput
  ) {
    onUpdateCorporate(filter: $filter) {
      id
      name
      furigana
      post
      pref
      address
      build
      tel
      fax
      logo
      sign
      bank {
        items {
          id
          corporateID
          corporate {
            id
            name
            furigana
            post
            pref
            address
            build
            tel
            fax
            logo
            sign
            slipFormat
            startMonth
            invoice
            createdAt
            updatedAt
            __typename
          }
          name
          store
          type
          no
          owner
          sort
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      office {
        items {
          id
          corporateID
          corporate {
            id
            name
            furigana
            post
            pref
            address
            build
            tel
            fax
            logo
            sign
            slipFormat
            startMonth
            invoice
            createdAt
            updatedAt
            __typename
          }
          name
          post
          pref
          address
          build
          tel
          fax
          sort
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      slipFormat
      startMonth
      invoice
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteCorporate = /* GraphQL */ `
  subscription OnDeleteCorporate(
    $filter: ModelSubscriptionCorporateFilterInput
  ) {
    onDeleteCorporate(filter: $filter) {
      id
      name
      furigana
      post
      pref
      address
      build
      tel
      fax
      logo
      sign
      bank {
        items {
          id
          corporateID
          corporate {
            id
            name
            furigana
            post
            pref
            address
            build
            tel
            fax
            logo
            sign
            slipFormat
            startMonth
            invoice
            createdAt
            updatedAt
            __typename
          }
          name
          store
          type
          no
          owner
          sort
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      office {
        items {
          id
          corporateID
          corporate {
            id
            name
            furigana
            post
            pref
            address
            build
            tel
            fax
            logo
            sign
            slipFormat
            startMonth
            invoice
            createdAt
            updatedAt
            __typename
          }
          name
          post
          pref
          address
          build
          tel
          fax
          sort
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      slipFormat
      startMonth
      invoice
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateOffice = /* GraphQL */ `
  subscription OnCreateOffice($filter: ModelSubscriptionOfficeFilterInput) {
    onCreateOffice(filter: $filter) {
      id
      corporateID
      corporate {
        id
        name
        furigana
        post
        pref
        address
        build
        tel
        fax
        logo
        sign
        bank {
          items {
            id
            corporateID
            name
            store
            type
            no
            owner
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        office {
          items {
            id
            corporateID
            name
            post
            pref
            address
            build
            tel
            fax
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        slipFormat
        startMonth
        invoice
        createdAt
        updatedAt
        __typename
      }
      name
      post
      pref
      address
      build
      tel
      fax
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateOffice = /* GraphQL */ `
  subscription OnUpdateOffice($filter: ModelSubscriptionOfficeFilterInput) {
    onUpdateOffice(filter: $filter) {
      id
      corporateID
      corporate {
        id
        name
        furigana
        post
        pref
        address
        build
        tel
        fax
        logo
        sign
        bank {
          items {
            id
            corporateID
            name
            store
            type
            no
            owner
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        office {
          items {
            id
            corporateID
            name
            post
            pref
            address
            build
            tel
            fax
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        slipFormat
        startMonth
        invoice
        createdAt
        updatedAt
        __typename
      }
      name
      post
      pref
      address
      build
      tel
      fax
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteOffice = /* GraphQL */ `
  subscription OnDeleteOffice($filter: ModelSubscriptionOfficeFilterInput) {
    onDeleteOffice(filter: $filter) {
      id
      corporateID
      corporate {
        id
        name
        furigana
        post
        pref
        address
        build
        tel
        fax
        logo
        sign
        bank {
          items {
            id
            corporateID
            name
            store
            type
            no
            owner
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        office {
          items {
            id
            corporateID
            name
            post
            pref
            address
            build
            tel
            fax
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        slipFormat
        startMonth
        invoice
        createdAt
        updatedAt
        __typename
      }
      name
      post
      pref
      address
      build
      tel
      fax
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateBank = /* GraphQL */ `
  subscription OnCreateBank($filter: ModelSubscriptionBankFilterInput) {
    onCreateBank(filter: $filter) {
      id
      corporateID
      corporate {
        id
        name
        furigana
        post
        pref
        address
        build
        tel
        fax
        logo
        sign
        bank {
          items {
            id
            corporateID
            name
            store
            type
            no
            owner
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        office {
          items {
            id
            corporateID
            name
            post
            pref
            address
            build
            tel
            fax
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        slipFormat
        startMonth
        invoice
        createdAt
        updatedAt
        __typename
      }
      name
      store
      type
      no
      owner
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateBank = /* GraphQL */ `
  subscription OnUpdateBank($filter: ModelSubscriptionBankFilterInput) {
    onUpdateBank(filter: $filter) {
      id
      corporateID
      corporate {
        id
        name
        furigana
        post
        pref
        address
        build
        tel
        fax
        logo
        sign
        bank {
          items {
            id
            corporateID
            name
            store
            type
            no
            owner
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        office {
          items {
            id
            corporateID
            name
            post
            pref
            address
            build
            tel
            fax
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        slipFormat
        startMonth
        invoice
        createdAt
        updatedAt
        __typename
      }
      name
      store
      type
      no
      owner
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteBank = /* GraphQL */ `
  subscription OnDeleteBank($filter: ModelSubscriptionBankFilterInput) {
    onDeleteBank(filter: $filter) {
      id
      corporateID
      corporate {
        id
        name
        furigana
        post
        pref
        address
        build
        tel
        fax
        logo
        sign
        bank {
          items {
            id
            corporateID
            name
            store
            type
            no
            owner
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        office {
          items {
            id
            corporateID
            name
            post
            pref
            address
            build
            tel
            fax
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        slipFormat
        startMonth
        invoice
        createdAt
        updatedAt
        __typename
      }
      name
      store
      type
      no
      owner
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateProject = /* GraphQL */ `
  subscription OnCreateProject($filter: ModelSubscriptionProjectFilterInput) {
    onCreateProject(filter: $filter) {
      id
      code
      name
      corporateID
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      deliveryDate
      documents {
        items {
          id
          projectID
          project {
            id
            code
            name
            corporateID
            customerID
            deliveryDate
            createdAt
            updatedAt
            __typename
          }
          name
          file
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      processes {
        items {
          id
          projectID
          project {
            id
            code
            name
            corporateID
            customerID
            deliveryDate
            createdAt
            updatedAt
            __typename
          }
          name
          parentID
          dependentOn
          charge
          start
          end
          progress
          color
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateProject = /* GraphQL */ `
  subscription OnUpdateProject($filter: ModelSubscriptionProjectFilterInput) {
    onUpdateProject(filter: $filter) {
      id
      code
      name
      corporateID
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      deliveryDate
      documents {
        items {
          id
          projectID
          project {
            id
            code
            name
            corporateID
            customerID
            deliveryDate
            createdAt
            updatedAt
            __typename
          }
          name
          file
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      processes {
        items {
          id
          projectID
          project {
            id
            code
            name
            corporateID
            customerID
            deliveryDate
            createdAt
            updatedAt
            __typename
          }
          name
          parentID
          dependentOn
          charge
          start
          end
          progress
          color
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteProject = /* GraphQL */ `
  subscription OnDeleteProject($filter: ModelSubscriptionProjectFilterInput) {
    onDeleteProject(filter: $filter) {
      id
      code
      name
      corporateID
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      deliveryDate
      documents {
        items {
          id
          projectID
          project {
            id
            code
            name
            corporateID
            customerID
            deliveryDate
            createdAt
            updatedAt
            __typename
          }
          name
          file
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      processes {
        items {
          id
          projectID
          project {
            id
            code
            name
            corporateID
            customerID
            deliveryDate
            createdAt
            updatedAt
            __typename
          }
          name
          parentID
          dependentOn
          charge
          start
          end
          progress
          color
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateDocument = /* GraphQL */ `
  subscription OnCreateDocument($filter: ModelSubscriptionDocumentFilterInput) {
    onCreateDocument(filter: $filter) {
      id
      projectID
      project {
        id
        code
        name
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        deliveryDate
        documents {
          items {
            id
            projectID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        processes {
          items {
            id
            projectID
            name
            parentID
            dependentOn
            charge
            start
            end
            progress
            color
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      name
      file
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateDocument = /* GraphQL */ `
  subscription OnUpdateDocument($filter: ModelSubscriptionDocumentFilterInput) {
    onUpdateDocument(filter: $filter) {
      id
      projectID
      project {
        id
        code
        name
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        deliveryDate
        documents {
          items {
            id
            projectID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        processes {
          items {
            id
            projectID
            name
            parentID
            dependentOn
            charge
            start
            end
            progress
            color
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      name
      file
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteDocument = /* GraphQL */ `
  subscription OnDeleteDocument($filter: ModelSubscriptionDocumentFilterInput) {
    onDeleteDocument(filter: $filter) {
      id
      projectID
      project {
        id
        code
        name
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        deliveryDate
        documents {
          items {
            id
            projectID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        processes {
          items {
            id
            projectID
            name
            parentID
            dependentOn
            charge
            start
            end
            progress
            color
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      name
      file
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateDialy = /* GraphQL */ `
  subscription OnCreateDialy($filter: ModelSubscriptionDialyFilterInput) {
    onCreateDialy(filter: $filter) {
      id
      userID
      user {
        id
        first
        last
        email
        phone
        birthday
        department
        director
        joinDate
        unitPrice
        enabled
        role
        corporateIDs
        remarks
        widgets {
          name
          enabled
          __typename
        }
        employmentType
        paidRemain
        paidHoursUsed
        dailyWorktime
        createdAt
        updatedAt
        __typename
      }
      start
      works {
        items {
          id
          dialyID
          dialy {
            id
            userID
            start
            probate
            unlock
            totalTime
            overTime
            midnightTime
            holidayTime
            holidayMignightTime
            createdAt
            updatedAt
            __typename
          }
          projectID
          project {
            id
            code
            name
            corporateID
            customerID
            deliveryDate
            createdAt
            updatedAt
            __typename
          }
          worktypeID
          workType {
            id
            code
            name
            createdAt
            updatedAt
            __typename
          }
          start
          end
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      probate
      unlock
      totalTime
      overTime
      midnightTime
      holidayTime
      holidayMignightTime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateDialy = /* GraphQL */ `
  subscription OnUpdateDialy($filter: ModelSubscriptionDialyFilterInput) {
    onUpdateDialy(filter: $filter) {
      id
      userID
      user {
        id
        first
        last
        email
        phone
        birthday
        department
        director
        joinDate
        unitPrice
        enabled
        role
        corporateIDs
        remarks
        widgets {
          name
          enabled
          __typename
        }
        employmentType
        paidRemain
        paidHoursUsed
        dailyWorktime
        createdAt
        updatedAt
        __typename
      }
      start
      works {
        items {
          id
          dialyID
          dialy {
            id
            userID
            start
            probate
            unlock
            totalTime
            overTime
            midnightTime
            holidayTime
            holidayMignightTime
            createdAt
            updatedAt
            __typename
          }
          projectID
          project {
            id
            code
            name
            corporateID
            customerID
            deliveryDate
            createdAt
            updatedAt
            __typename
          }
          worktypeID
          workType {
            id
            code
            name
            createdAt
            updatedAt
            __typename
          }
          start
          end
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      probate
      unlock
      totalTime
      overTime
      midnightTime
      holidayTime
      holidayMignightTime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteDialy = /* GraphQL */ `
  subscription OnDeleteDialy($filter: ModelSubscriptionDialyFilterInput) {
    onDeleteDialy(filter: $filter) {
      id
      userID
      user {
        id
        first
        last
        email
        phone
        birthday
        department
        director
        joinDate
        unitPrice
        enabled
        role
        corporateIDs
        remarks
        widgets {
          name
          enabled
          __typename
        }
        employmentType
        paidRemain
        paidHoursUsed
        dailyWorktime
        createdAt
        updatedAt
        __typename
      }
      start
      works {
        items {
          id
          dialyID
          dialy {
            id
            userID
            start
            probate
            unlock
            totalTime
            overTime
            midnightTime
            holidayTime
            holidayMignightTime
            createdAt
            updatedAt
            __typename
          }
          projectID
          project {
            id
            code
            name
            corporateID
            customerID
            deliveryDate
            createdAt
            updatedAt
            __typename
          }
          worktypeID
          workType {
            id
            code
            name
            createdAt
            updatedAt
            __typename
          }
          start
          end
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      probate
      unlock
      totalTime
      overTime
      midnightTime
      holidayTime
      holidayMignightTime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateWork = /* GraphQL */ `
  subscription OnCreateWork($filter: ModelSubscriptionWorkFilterInput) {
    onCreateWork(filter: $filter) {
      id
      dialyID
      dialy {
        id
        userID
        user {
          id
          first
          last
          email
          phone
          birthday
          department
          director
          joinDate
          unitPrice
          enabled
          role
          corporateIDs
          remarks
          widgets {
            name
            enabled
            __typename
          }
          employmentType
          paidRemain
          paidHoursUsed
          dailyWorktime
          createdAt
          updatedAt
          __typename
        }
        start
        works {
          items {
            id
            dialyID
            projectID
            worktypeID
            start
            end
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        probate
        unlock
        totalTime
        overTime
        midnightTime
        holidayTime
        holidayMignightTime
        createdAt
        updatedAt
        __typename
      }
      projectID
      project {
        id
        code
        name
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        deliveryDate
        documents {
          items {
            id
            projectID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        processes {
          items {
            id
            projectID
            name
            parentID
            dependentOn
            charge
            start
            end
            progress
            color
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      worktypeID
      workType {
        id
        code
        name
        createdAt
        updatedAt
        __typename
      }
      start
      end
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateWork = /* GraphQL */ `
  subscription OnUpdateWork($filter: ModelSubscriptionWorkFilterInput) {
    onUpdateWork(filter: $filter) {
      id
      dialyID
      dialy {
        id
        userID
        user {
          id
          first
          last
          email
          phone
          birthday
          department
          director
          joinDate
          unitPrice
          enabled
          role
          corporateIDs
          remarks
          widgets {
            name
            enabled
            __typename
          }
          employmentType
          paidRemain
          paidHoursUsed
          dailyWorktime
          createdAt
          updatedAt
          __typename
        }
        start
        works {
          items {
            id
            dialyID
            projectID
            worktypeID
            start
            end
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        probate
        unlock
        totalTime
        overTime
        midnightTime
        holidayTime
        holidayMignightTime
        createdAt
        updatedAt
        __typename
      }
      projectID
      project {
        id
        code
        name
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        deliveryDate
        documents {
          items {
            id
            projectID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        processes {
          items {
            id
            projectID
            name
            parentID
            dependentOn
            charge
            start
            end
            progress
            color
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      worktypeID
      workType {
        id
        code
        name
        createdAt
        updatedAt
        __typename
      }
      start
      end
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteWork = /* GraphQL */ `
  subscription OnDeleteWork($filter: ModelSubscriptionWorkFilterInput) {
    onDeleteWork(filter: $filter) {
      id
      dialyID
      dialy {
        id
        userID
        user {
          id
          first
          last
          email
          phone
          birthday
          department
          director
          joinDate
          unitPrice
          enabled
          role
          corporateIDs
          remarks
          widgets {
            name
            enabled
            __typename
          }
          employmentType
          paidRemain
          paidHoursUsed
          dailyWorktime
          createdAt
          updatedAt
          __typename
        }
        start
        works {
          items {
            id
            dialyID
            projectID
            worktypeID
            start
            end
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        probate
        unlock
        totalTime
        overTime
        midnightTime
        holidayTime
        holidayMignightTime
        createdAt
        updatedAt
        __typename
      }
      projectID
      project {
        id
        code
        name
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        deliveryDate
        documents {
          items {
            id
            projectID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        processes {
          items {
            id
            projectID
            name
            parentID
            dependentOn
            charge
            start
            end
            progress
            color
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      worktypeID
      workType {
        id
        code
        name
        createdAt
        updatedAt
        __typename
      }
      start
      end
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateWorkType = /* GraphQL */ `
  subscription OnCreateWorkType($filter: ModelSubscriptionWorkTypeFilterInput) {
    onCreateWorkType(filter: $filter) {
      id
      code
      name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateWorkType = /* GraphQL */ `
  subscription OnUpdateWorkType($filter: ModelSubscriptionWorkTypeFilterInput) {
    onUpdateWorkType(filter: $filter) {
      id
      code
      name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteWorkType = /* GraphQL */ `
  subscription OnDeleteWorkType($filter: ModelSubscriptionWorkTypeFilterInput) {
    onDeleteWorkType(filter: $filter) {
      id
      code
      name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateWorkTimeGroup = /* GraphQL */ `
  subscription OnCreateWorkTimeGroup(
    $filter: ModelSubscriptionWorkTimeGroupFilterInput
  ) {
    onCreateWorkTimeGroup(filter: $filter) {
      id
      start
      end
      workTimes {
        items {
          id
          groupID
          start
          end
          name
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateWorkTimeGroup = /* GraphQL */ `
  subscription OnUpdateWorkTimeGroup(
    $filter: ModelSubscriptionWorkTimeGroupFilterInput
  ) {
    onUpdateWorkTimeGroup(filter: $filter) {
      id
      start
      end
      workTimes {
        items {
          id
          groupID
          start
          end
          name
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteWorkTimeGroup = /* GraphQL */ `
  subscription OnDeleteWorkTimeGroup(
    $filter: ModelSubscriptionWorkTimeGroupFilterInput
  ) {
    onDeleteWorkTimeGroup(filter: $filter) {
      id
      start
      end
      workTimes {
        items {
          id
          groupID
          start
          end
          name
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateWorkTime = /* GraphQL */ `
  subscription OnCreateWorkTime($filter: ModelSubscriptionWorkTimeFilterInput) {
    onCreateWorkTime(filter: $filter) {
      id
      groupID
      start
      end
      name
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateWorkTime = /* GraphQL */ `
  subscription OnUpdateWorkTime($filter: ModelSubscriptionWorkTimeFilterInput) {
    onUpdateWorkTime(filter: $filter) {
      id
      groupID
      start
      end
      name
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteWorkTime = /* GraphQL */ `
  subscription OnDeleteWorkTime($filter: ModelSubscriptionWorkTimeFilterInput) {
    onDeleteWorkTime(filter: $filter) {
      id
      groupID
      start
      end
      name
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateEvent = /* GraphQL */ `
  subscription OnCreateEvent($filter: ModelSubscriptionEventFilterInput) {
    onCreateEvent(filter: $filter) {
      id
      start
      end
      name
      type
      color
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateEvent = /* GraphQL */ `
  subscription OnUpdateEvent($filter: ModelSubscriptionEventFilterInput) {
    onUpdateEvent(filter: $filter) {
      id
      start
      end
      name
      type
      color
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteEvent = /* GraphQL */ `
  subscription OnDeleteEvent($filter: ModelSubscriptionEventFilterInput) {
    onDeleteEvent(filter: $filter) {
      id
      start
      end
      name
      type
      color
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateProcess = /* GraphQL */ `
  subscription OnCreateProcess($filter: ModelSubscriptionProcessFilterInput) {
    onCreateProcess(filter: $filter) {
      id
      projectID
      project {
        id
        code
        name
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        deliveryDate
        documents {
          items {
            id
            projectID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        processes {
          items {
            id
            projectID
            name
            parentID
            dependentOn
            charge
            start
            end
            progress
            color
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      name
      parentID
      dependentOn
      charge
      start
      end
      progress
      color
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateProcess = /* GraphQL */ `
  subscription OnUpdateProcess($filter: ModelSubscriptionProcessFilterInput) {
    onUpdateProcess(filter: $filter) {
      id
      projectID
      project {
        id
        code
        name
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        deliveryDate
        documents {
          items {
            id
            projectID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        processes {
          items {
            id
            projectID
            name
            parentID
            dependentOn
            charge
            start
            end
            progress
            color
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      name
      parentID
      dependentOn
      charge
      start
      end
      progress
      color
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteProcess = /* GraphQL */ `
  subscription OnDeleteProcess($filter: ModelSubscriptionProcessFilterInput) {
    onDeleteProcess(filter: $filter) {
      id
      projectID
      project {
        id
        code
        name
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        deliveryDate
        documents {
          items {
            id
            projectID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        processes {
          items {
            id
            projectID
            name
            parentID
            dependentOn
            charge
            start
            end
            progress
            color
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      name
      parentID
      dependentOn
      charge
      start
      end
      progress
      color
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateProduct = /* GraphQL */ `
  subscription OnCreateProduct($filter: ModelSubscriptionProductFilterInput) {
    onCreateProduct(filter: $filter) {
      id
      category
      name
      mainTitle
      subTitle
      mainPic
      models {
        items {
          id
          productID
          product {
            id
            category
            name
            mainTitle
            subTitle
            mainPic
            publish
            createdAt
            updatedAt
            __typename
          }
          serial
          name
          code
          size
          color
          material
          value
          remark
          mainPic
          customerID
          remain
          inventory
          publish
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      files {
        items {
          id
          productID
          product {
            id
            category
            name
            mainTitle
            subTitle
            mainPic
            publish
            createdAt
            updatedAt
            __typename
          }
          name
          file
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      publish
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateProduct = /* GraphQL */ `
  subscription OnUpdateProduct($filter: ModelSubscriptionProductFilterInput) {
    onUpdateProduct(filter: $filter) {
      id
      category
      name
      mainTitle
      subTitle
      mainPic
      models {
        items {
          id
          productID
          product {
            id
            category
            name
            mainTitle
            subTitle
            mainPic
            publish
            createdAt
            updatedAt
            __typename
          }
          serial
          name
          code
          size
          color
          material
          value
          remark
          mainPic
          customerID
          remain
          inventory
          publish
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      files {
        items {
          id
          productID
          product {
            id
            category
            name
            mainTitle
            subTitle
            mainPic
            publish
            createdAt
            updatedAt
            __typename
          }
          name
          file
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      publish
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteProduct = /* GraphQL */ `
  subscription OnDeleteProduct($filter: ModelSubscriptionProductFilterInput) {
    onDeleteProduct(filter: $filter) {
      id
      category
      name
      mainTitle
      subTitle
      mainPic
      models {
        items {
          id
          productID
          product {
            id
            category
            name
            mainTitle
            subTitle
            mainPic
            publish
            createdAt
            updatedAt
            __typename
          }
          serial
          name
          code
          size
          color
          material
          value
          remark
          mainPic
          customerID
          remain
          inventory
          publish
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      files {
        items {
          id
          productID
          product {
            id
            category
            name
            mainTitle
            subTitle
            mainPic
            publish
            createdAt
            updatedAt
            __typename
          }
          name
          file
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      publish
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateModel = /* GraphQL */ `
  subscription OnCreateModel($filter: ModelSubscriptionModelFilterInput) {
    onCreateModel(filter: $filter) {
      id
      productID
      product {
        id
        category
        name
        mainTitle
        subTitle
        mainPic
        models {
          items {
            id
            productID
            serial
            name
            code
            size
            color
            material
            value
            remark
            mainPic
            customerID
            remain
            inventory
            publish
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        files {
          items {
            id
            productID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        publish
        createdAt
        updatedAt
        __typename
      }
      serial
      name
      code
      size
      color
      material
      value
      remark
      mainPic
      customerID
      remain
      inventory
      publish
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateModel = /* GraphQL */ `
  subscription OnUpdateModel($filter: ModelSubscriptionModelFilterInput) {
    onUpdateModel(filter: $filter) {
      id
      productID
      product {
        id
        category
        name
        mainTitle
        subTitle
        mainPic
        models {
          items {
            id
            productID
            serial
            name
            code
            size
            color
            material
            value
            remark
            mainPic
            customerID
            remain
            inventory
            publish
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        files {
          items {
            id
            productID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        publish
        createdAt
        updatedAt
        __typename
      }
      serial
      name
      code
      size
      color
      material
      value
      remark
      mainPic
      customerID
      remain
      inventory
      publish
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteModel = /* GraphQL */ `
  subscription OnDeleteModel($filter: ModelSubscriptionModelFilterInput) {
    onDeleteModel(filter: $filter) {
      id
      productID
      product {
        id
        category
        name
        mainTitle
        subTitle
        mainPic
        models {
          items {
            id
            productID
            serial
            name
            code
            size
            color
            material
            value
            remark
            mainPic
            customerID
            remain
            inventory
            publish
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        files {
          items {
            id
            productID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        publish
        createdAt
        updatedAt
        __typename
      }
      serial
      name
      code
      size
      color
      material
      value
      remark
      mainPic
      customerID
      remain
      inventory
      publish
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateSubModel = /* GraphQL */ `
  subscription OnCreateSubModel($filter: ModelSubscriptionSubModelFilterInput) {
    onCreateSubModel(filter: $filter) {
      id
      modelID
      model {
        id
        productID
        product {
          id
          category
          name
          mainTitle
          subTitle
          mainPic
          models {
            nextToken
            __typename
          }
          files {
            nextToken
            __typename
          }
          publish
          createdAt
          updatedAt
          __typename
        }
        serial
        name
        code
        size
        color
        material
        value
        remark
        mainPic
        customerID
        remain
        inventory
        publish
        createdAt
        updatedAt
        __typename
      }
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      name
      code
      value
      enabled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateSubModel = /* GraphQL */ `
  subscription OnUpdateSubModel($filter: ModelSubscriptionSubModelFilterInput) {
    onUpdateSubModel(filter: $filter) {
      id
      modelID
      model {
        id
        productID
        product {
          id
          category
          name
          mainTitle
          subTitle
          mainPic
          models {
            nextToken
            __typename
          }
          files {
            nextToken
            __typename
          }
          publish
          createdAt
          updatedAt
          __typename
        }
        serial
        name
        code
        size
        color
        material
        value
        remark
        mainPic
        customerID
        remain
        inventory
        publish
        createdAt
        updatedAt
        __typename
      }
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      name
      code
      value
      enabled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteSubModel = /* GraphQL */ `
  subscription OnDeleteSubModel($filter: ModelSubscriptionSubModelFilterInput) {
    onDeleteSubModel(filter: $filter) {
      id
      modelID
      model {
        id
        productID
        product {
          id
          category
          name
          mainTitle
          subTitle
          mainPic
          models {
            nextToken
            __typename
          }
          files {
            nextToken
            __typename
          }
          publish
          createdAt
          updatedAt
          __typename
        }
        serial
        name
        code
        size
        color
        material
        value
        remark
        mainPic
        customerID
        remain
        inventory
        publish
        createdAt
        updatedAt
        __typename
      }
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      name
      code
      value
      enabled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateFile = /* GraphQL */ `
  subscription OnCreateFile($filter: ModelSubscriptionFileFilterInput) {
    onCreateFile(filter: $filter) {
      id
      productID
      product {
        id
        category
        name
        mainTitle
        subTitle
        mainPic
        models {
          items {
            id
            productID
            serial
            name
            code
            size
            color
            material
            value
            remark
            mainPic
            customerID
            remain
            inventory
            publish
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        files {
          items {
            id
            productID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        publish
        createdAt
        updatedAt
        __typename
      }
      name
      file
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateFile = /* GraphQL */ `
  subscription OnUpdateFile($filter: ModelSubscriptionFileFilterInput) {
    onUpdateFile(filter: $filter) {
      id
      productID
      product {
        id
        category
        name
        mainTitle
        subTitle
        mainPic
        models {
          items {
            id
            productID
            serial
            name
            code
            size
            color
            material
            value
            remark
            mainPic
            customerID
            remain
            inventory
            publish
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        files {
          items {
            id
            productID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        publish
        createdAt
        updatedAt
        __typename
      }
      name
      file
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteFile = /* GraphQL */ `
  subscription OnDeleteFile($filter: ModelSubscriptionFileFilterInput) {
    onDeleteFile(filter: $filter) {
      id
      productID
      product {
        id
        category
        name
        mainTitle
        subTitle
        mainPic
        models {
          items {
            id
            productID
            serial
            name
            code
            size
            color
            material
            value
            remark
            mainPic
            customerID
            remain
            inventory
            publish
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        files {
          items {
            id
            productID
            name
            file
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        publish
        createdAt
        updatedAt
        __typename
      }
      name
      file
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateOrder = /* GraphQL */ `
  subscription OnCreateOrder($filter: ModelSubscriptionOrderFilterInput) {
    onCreateOrder(filter: $filter) {
      id
      corporateID
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      projectID
      agencyID
      amount
      tax
      payment
      complete
      publish
      status
      transactionID
      transactionDate
      processID
      processPass
      createdAt
      estimateDate
      estimateLimit
      orderDate
      claimDate
      fixedDate
      paymentDate
      paymentTerms
      deliveryDate
      title
      remarks
      officeID
      chargeID
      orderItems {
        items {
          id
          orderID
          order {
            id
            corporateID
            customerID
            projectID
            agencyID
            amount
            tax
            payment
            complete
            publish
            status
            transactionID
            transactionDate
            processID
            processPass
            createdAt
            estimateDate
            estimateLimit
            orderDate
            claimDate
            fixedDate
            paymentDate
            paymentTerms
            deliveryDate
            title
            remarks
            officeID
            chargeID
            updatedAt
            __typename
          }
          modelID
          subModelID
          name
          quantity
          unit
          value
          remarks
          sort
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const onUpdateOrder = /* GraphQL */ `
  subscription OnUpdateOrder($filter: ModelSubscriptionOrderFilterInput) {
    onUpdateOrder(filter: $filter) {
      id
      corporateID
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      projectID
      agencyID
      amount
      tax
      payment
      complete
      publish
      status
      transactionID
      transactionDate
      processID
      processPass
      createdAt
      estimateDate
      estimateLimit
      orderDate
      claimDate
      fixedDate
      paymentDate
      paymentTerms
      deliveryDate
      title
      remarks
      officeID
      chargeID
      orderItems {
        items {
          id
          orderID
          order {
            id
            corporateID
            customerID
            projectID
            agencyID
            amount
            tax
            payment
            complete
            publish
            status
            transactionID
            transactionDate
            processID
            processPass
            createdAt
            estimateDate
            estimateLimit
            orderDate
            claimDate
            fixedDate
            paymentDate
            paymentTerms
            deliveryDate
            title
            remarks
            officeID
            chargeID
            updatedAt
            __typename
          }
          modelID
          subModelID
          name
          quantity
          unit
          value
          remarks
          sort
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const onDeleteOrder = /* GraphQL */ `
  subscription OnDeleteOrder($filter: ModelSubscriptionOrderFilterInput) {
    onDeleteOrder(filter: $filter) {
      id
      corporateID
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      projectID
      agencyID
      amount
      tax
      payment
      complete
      publish
      status
      transactionID
      transactionDate
      processID
      processPass
      createdAt
      estimateDate
      estimateLimit
      orderDate
      claimDate
      fixedDate
      paymentDate
      paymentTerms
      deliveryDate
      title
      remarks
      officeID
      chargeID
      orderItems {
        items {
          id
          orderID
          order {
            id
            corporateID
            customerID
            projectID
            agencyID
            amount
            tax
            payment
            complete
            publish
            status
            transactionID
            transactionDate
            processID
            processPass
            createdAt
            estimateDate
            estimateLimit
            orderDate
            claimDate
            fixedDate
            paymentDate
            paymentTerms
            deliveryDate
            title
            remarks
            officeID
            chargeID
            updatedAt
            __typename
          }
          modelID
          subModelID
          name
          quantity
          unit
          value
          remarks
          sort
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const onCreateOrderItem = /* GraphQL */ `
  subscription OnCreateOrderItem(
    $filter: ModelSubscriptionOrderItemFilterInput
  ) {
    onCreateOrderItem(filter: $filter) {
      id
      orderID
      order {
        id
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        projectID
        agencyID
        amount
        tax
        payment
        complete
        publish
        status
        transactionID
        transactionDate
        processID
        processPass
        createdAt
        estimateDate
        estimateLimit
        orderDate
        claimDate
        fixedDate
        paymentDate
        paymentTerms
        deliveryDate
        title
        remarks
        officeID
        chargeID
        orderItems {
          items {
            id
            orderID
            modelID
            subModelID
            name
            quantity
            unit
            value
            remarks
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      modelID
      subModelID
      name
      quantity
      unit
      value
      remarks
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateOrderItem = /* GraphQL */ `
  subscription OnUpdateOrderItem(
    $filter: ModelSubscriptionOrderItemFilterInput
  ) {
    onUpdateOrderItem(filter: $filter) {
      id
      orderID
      order {
        id
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        projectID
        agencyID
        amount
        tax
        payment
        complete
        publish
        status
        transactionID
        transactionDate
        processID
        processPass
        createdAt
        estimateDate
        estimateLimit
        orderDate
        claimDate
        fixedDate
        paymentDate
        paymentTerms
        deliveryDate
        title
        remarks
        officeID
        chargeID
        orderItems {
          items {
            id
            orderID
            modelID
            subModelID
            name
            quantity
            unit
            value
            remarks
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      modelID
      subModelID
      name
      quantity
      unit
      value
      remarks
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteOrderItem = /* GraphQL */ `
  subscription OnDeleteOrderItem(
    $filter: ModelSubscriptionOrderItemFilterInput
  ) {
    onDeleteOrderItem(filter: $filter) {
      id
      orderID
      order {
        id
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        projectID
        agencyID
        amount
        tax
        payment
        complete
        publish
        status
        transactionID
        transactionDate
        processID
        processPass
        createdAt
        estimateDate
        estimateLimit
        orderDate
        claimDate
        fixedDate
        paymentDate
        paymentTerms
        deliveryDate
        title
        remarks
        officeID
        chargeID
        orderItems {
          items {
            id
            orderID
            modelID
            subModelID
            name
            quantity
            unit
            value
            remarks
            sort
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      modelID
      subModelID
      name
      quantity
      unit
      value
      remarks
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateStock = /* GraphQL */ `
  subscription OnCreateStock($filter: ModelSubscriptionStockFilterInput) {
    onCreateStock(filter: $filter) {
      id
      userID
      customerID
      modelID
      quantity
      total
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateStock = /* GraphQL */ `
  subscription OnUpdateStock($filter: ModelSubscriptionStockFilterInput) {
    onUpdateStock(filter: $filter) {
      id
      userID
      customerID
      modelID
      quantity
      total
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteStock = /* GraphQL */ `
  subscription OnDeleteStock($filter: ModelSubscriptionStockFilterInput) {
    onDeleteStock(filter: $filter) {
      id
      userID
      customerID
      modelID
      quantity
      total
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreatePaymentDoc = /* GraphQL */ `
  subscription OnCreatePaymentDoc(
    $filter: ModelSubscriptionPaymentDocFilterInput
  ) {
    onCreatePaymentDoc(filter: $filter) {
      id
      corporateID
      pic
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdatePaymentDoc = /* GraphQL */ `
  subscription OnUpdatePaymentDoc(
    $filter: ModelSubscriptionPaymentDocFilterInput
  ) {
    onUpdatePaymentDoc(filter: $filter) {
      id
      corporateID
      pic
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeletePaymentDoc = /* GraphQL */ `
  subscription OnDeletePaymentDoc(
    $filter: ModelSubscriptionPaymentDocFilterInput
  ) {
    onDeletePaymentDoc(filter: $filter) {
      id
      corporateID
      pic
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreatePayment = /* GraphQL */ `
  subscription OnCreatePayment($filter: ModelSubscriptionPaymentFilterInput) {
    onCreatePayment(filter: $filter) {
      id
      no
      title
      kind
      corporateID
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      orderDate
      claimDate
      fixedDate
      paymentDate
      amount
      tax
      payment
      commission
      complete
      pic
      remarks
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdatePayment = /* GraphQL */ `
  subscription OnUpdatePayment($filter: ModelSubscriptionPaymentFilterInput) {
    onUpdatePayment(filter: $filter) {
      id
      no
      title
      kind
      corporateID
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      orderDate
      claimDate
      fixedDate
      paymentDate
      amount
      tax
      payment
      commission
      complete
      pic
      remarks
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeletePayment = /* GraphQL */ `
  subscription OnDeletePayment($filter: ModelSubscriptionPaymentFilterInput) {
    onDeletePayment(filter: $filter) {
      id
      no
      title
      kind
      corporateID
      customerID
      customer {
        id
        email
        passwd
        serial
        name
        office
        post
        pref
        address
        build
        tel
        fax
        url
        agencyID
        closing
        payment
        rate
        charge
        salesID
        color
        createdAt
        updatedAt
        __typename
      }
      orderDate
      claimDate
      fixedDate
      paymentDate
      amount
      tax
      payment
      commission
      complete
      pic
      remarks
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreatePaymentItem = /* GraphQL */ `
  subscription OnCreatePaymentItem(
    $filter: ModelSubscriptionPaymentItemFilterInput
  ) {
    onCreatePaymentItem(filter: $filter) {
      id
      paymentID
      payment {
        id
        no
        title
        kind
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        orderDate
        claimDate
        fixedDate
        paymentDate
        amount
        tax
        payment
        commission
        complete
        pic
        remarks
        createdAt
        updatedAt
        __typename
      }
      modelID
      subModelID
      name
      quantity
      unit
      value
      remarks
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdatePaymentItem = /* GraphQL */ `
  subscription OnUpdatePaymentItem(
    $filter: ModelSubscriptionPaymentItemFilterInput
  ) {
    onUpdatePaymentItem(filter: $filter) {
      id
      paymentID
      payment {
        id
        no
        title
        kind
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        orderDate
        claimDate
        fixedDate
        paymentDate
        amount
        tax
        payment
        commission
        complete
        pic
        remarks
        createdAt
        updatedAt
        __typename
      }
      modelID
      subModelID
      name
      quantity
      unit
      value
      remarks
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeletePaymentItem = /* GraphQL */ `
  subscription OnDeletePaymentItem(
    $filter: ModelSubscriptionPaymentItemFilterInput
  ) {
    onDeletePaymentItem(filter: $filter) {
      id
      paymentID
      payment {
        id
        no
        title
        kind
        corporateID
        customerID
        customer {
          id
          email
          passwd
          serial
          name
          office
          post
          pref
          address
          build
          tel
          fax
          url
          agencyID
          closing
          payment
          rate
          charge
          salesID
          color
          createdAt
          updatedAt
          __typename
        }
        orderDate
        claimDate
        fixedDate
        paymentDate
        amount
        tax
        payment
        commission
        complete
        pic
        remarks
        createdAt
        updatedAt
        __typename
      }
      modelID
      subModelID
      name
      quantity
      unit
      value
      remarks
      sort
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateFacility = /* GraphQL */ `
  subscription OnCreateFacility($filter: ModelSubscriptionFacilityFilterInput) {
    onCreateFacility(filter: $filter) {
      id
      group
      name
      type
      enableWeek
      enableTime
      enableFewMonth
      minMinutes
      publish
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateFacility = /* GraphQL */ `
  subscription OnUpdateFacility($filter: ModelSubscriptionFacilityFilterInput) {
    onUpdateFacility(filter: $filter) {
      id
      group
      name
      type
      enableWeek
      enableTime
      enableFewMonth
      minMinutes
      publish
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteFacility = /* GraphQL */ `
  subscription OnDeleteFacility($filter: ModelSubscriptionFacilityFilterInput) {
    onDeleteFacility(filter: $filter) {
      id
      group
      name
      type
      enableWeek
      enableTime
      enableFewMonth
      minMinutes
      publish
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateFacilityReserve = /* GraphQL */ `
  subscription OnCreateFacilityReserve(
    $filter: ModelSubscriptionFacilityReserveFilterInput
  ) {
    onCreateFacilityReserve(filter: $filter) {
      id
      facilityID
      customerID
      name
      start
      end
      color
      remarks
      charge
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateFacilityReserve = /* GraphQL */ `
  subscription OnUpdateFacilityReserve(
    $filter: ModelSubscriptionFacilityReserveFilterInput
  ) {
    onUpdateFacilityReserve(filter: $filter) {
      id
      facilityID
      customerID
      name
      start
      end
      color
      remarks
      charge
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteFacilityReserve = /* GraphQL */ `
  subscription OnDeleteFacilityReserve(
    $filter: ModelSubscriptionFacilityReserveFilterInput
  ) {
    onDeleteFacilityReserve(filter: $filter) {
      id
      facilityID
      customerID
      name
      start
      end
      color
      remarks
      charge
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateAttendance = /* GraphQL */ `
  subscription OnCreateAttendance(
    $filter: ModelSubscriptionAttendanceFilterInput
  ) {
    onCreateAttendance(filter: $filter) {
      id
      userID
      temperature
      mask
      alcohol
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateAttendance = /* GraphQL */ `
  subscription OnUpdateAttendance(
    $filter: ModelSubscriptionAttendanceFilterInput
  ) {
    onUpdateAttendance(filter: $filter) {
      id
      userID
      temperature
      mask
      alcohol
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteAttendance = /* GraphQL */ `
  subscription OnDeleteAttendance(
    $filter: ModelSubscriptionAttendanceFilterInput
  ) {
    onDeleteAttendance(filter: $filter) {
      id
      userID
      temperature
      mask
      alcohol
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateLog = /* GraphQL */ `
  subscription OnCreateLog($filter: ModelSubscriptionLogFilterInput) {
    onCreateLog(filter: $filter) {
      id
      userID
      customerID
      type
      text
      createdAt
      ttl
      updatedAt
      __typename
    }
  }
`;
export const onUpdateLog = /* GraphQL */ `
  subscription OnUpdateLog($filter: ModelSubscriptionLogFilterInput) {
    onUpdateLog(filter: $filter) {
      id
      userID
      customerID
      type
      text
      createdAt
      ttl
      updatedAt
      __typename
    }
  }
`;
export const onDeleteLog = /* GraphQL */ `
  subscription OnDeleteLog($filter: ModelSubscriptionLogFilterInput) {
    onDeleteLog(filter: $filter) {
      id
      userID
      customerID
      type
      text
      createdAt
      ttl
      updatedAt
      __typename
    }
  }
`;
